import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#EB578A",
      dark: "#C0145E",
      light: "#F7A8C4",
      contrastText: "#fff",
    },
    secondary: {
      main: "#C0145E",
    },
    background: {
      default: "#fff8fb",
      paper: "#ffffff",
    },
    error: {
      main: "#e53935",
    },
  },
  typography: {
    fontFamily: "'Lato', 'Arial', sans-serif",
    h4: { fontWeight: 800 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 700,
          borderRadius: 10,
        },
        contained: {
          boxShadow: "0 2px 8px rgba(235,87,138,0.25)",
          "&:hover": {
            boxShadow: "0 4px 14px rgba(235,87,138,0.4)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#EB578A",
              borderWidth: 2,
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#EB578A",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiCircularProgress: {
      defaultProps: {
        size: 36,
      },
      styleOverrides: {
        root: {
          color: "#EB578A",
        },
      },
    },
  },
});

export default theme;
